export const getDotSize = ({
  isActive = false,
  isNext = false,
  isPrevious = false
} = {}) => {
  if (isActive) {
    return '12px';
  } else if (isNext || isPrevious) {
    return '4px';
  }
  return '8px';
};
//# sourceMappingURL=getDotSize.js.map